<template>
  <div class="container page">
    <van-nav-bar class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #title>
        <span class="nav-title">{{ videoInfo.vod_name || title }}</span>
      </template>
    </van-nav-bar>
    <div id="content">
      <div class="movie-video">
        <video :id="videoId"  class="video-js">
        </video>
      </div>
      <div class="movie-content">
        <div class="movie-descript">
          <p>{{ this.videoInfo.vod_name || title}}</p>
          <span>{{this.videoInfo.count}} {{ $t("videoDetail.count") }}</span>
        </div>

        <div class="movie-body">
          <div class="movie-title">
            <van-image src="img/video/hot.png" width="20"></van-image>
            <span>{{ $t("videoDetail.title") }}</span>
          </div>
          
          <div class="wrap">
              <div class="video_wrap" v-for="(v,key) in moreVideoInfo" :key="key" @click="toPlayVideo(v.id)">
                <div class="video">
                  <van-image  :src="v.vod_pic"></van-image>
                  <div class="info">
                    <span class="label">{{v.vod_name}}</span>
                    <span class="value">{{$t("videoDetail.count")}}: {{v.count}}</span>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover:"",
      userInfo:[],
      videoInfo:{},
      moreVideoInfo:{},
      player:null,
      is_play:false,
      times: null,
      is_see:0,
      title: '',
    };
  },
  computed: {
    videoId() {
      return `video${Date.parse(new Date())}`
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    getVideoInfo(){
      
      this.$http({
        method: 'get',
        data:{id:this.$route.query.id},
        url: 'video_get_info'
      }).then(res=>{
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.cover = this.videoInfo.vod_pic;
        this.player.poster = this.cover
        this.getVideo();
      })

    },
    toPlayVideo(id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'?id='+id})
        location.reload();
      }

    },
    getMoreVideoItem(){
      this.$http({
        method: 'get',
        url: 'video_get_more_item'
      }).then(res=>{
          this.moreVideoInfo = res.data;
      })
    },
    getVideo() {
      // this.player = videojs("my-video",  {
      //   height:"200px",
      //   preload: "auto", // 预加载
      //   controls: true,  // 显示播放的控件
      //   multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      // });
      this.player.src([{
        src: this.nowPlayVideoUrl,
        type: "video/mp4" // mp4 直链
      }]);
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.is_see = this.userInfo.is_see;
          if(this.userInfo.status !== 1){
            this.$toast(this.$t("videoDetail.account_out"));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }else {
            if(this.$store.getters.getBaseInfo.isplay == 1){
              this.getVideoInfo();
              this.getMoreVideoItem()
              // if(this.userInfo.money <= "0.00"){
              //   this.$toast(this.$t("videoDetail.buy"));
              //   this.$router.push({path:'/Home'})
              // }
            }else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
  },
  mounted(){
    const _this = this;
    this.title = this.$route.query.title
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.player = videojs(this.videoId,  {
        height:"240px",
        preload: "auto", // 预加载
        controls: true,  // 显示播放的控件
        multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      },function(){
        this.on("play",() => {
          _this.is_play=true;
        });
      });
      this.getUserInfo();
      this.times = setInterval(() => {
        if(this.is_play && this.is_see == 0){
          const ct = Math.round(this.player.currentTime())
          if(ct >= 180){
            this.player.pause()
            this.$toast(this.$t("videoDetail.buy"));
            return
          }
        } 
      }, 1000 * 2);
    }

  },

  destroyed () {
    if(this.is_play){
      this.is_play = false;
    }
    clearInterval(this.times);
  }
};
</script>

<style scoped lang="less">
.page {
  min-height: 100%;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
}
.nav-title {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.95rem;
  color: #fff;
}
.video-js {
  width: 100%;
  font-size: 0.9rem;
}
.movie-video {
  background: #1c1424;
}
.movie-content{
  flex: 1;
  overflow-y: auto;
  padding-bottom: 1.2rem;
}
.movie-content .movie-descript{
  width: auto;
  margin: 0.75rem 4% 0;
  background-color: #fff;
  border-radius: 1.1rem;
  box-shadow: 0 0.35rem 1rem rgba(183, 156, 236, 0.14);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.85rem 0.9rem;
  span {
    margin-top: 0.45rem;
    padding: 0.2rem 0.55rem;
    background: #ffeaf1;
    color: #e0739b;
    display: inline-block;
    font-size: .78rem;
    border-radius: 1rem;
  }
}
.movie-content .movie-descript p{
  width: 100%;
  font-size: 1rem;
  line-height: 1.45;
  font-weight: 700;
  color: #4a3a5c;
  word-break: break-word;
}
.movie-content .movie-descript span{
  // color: #979799;
}
.movie-content .movie-body{
  width: calc(100% - 20px);
  margin: 0 auto;
}
.movie-content .movie-body .movie-title{
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.9rem 0.2rem 0.2rem;
  span{
    color: #4a3a5c;
    margin-left: 0.4rem;
    font-size: 1rem;
    font-weight: 700;
    display: inline-block;
  }
}
.movie-content .movie-body .movie-title>div:first-child {
  width: auto;
  max-width: 100%;
}
.movie-content .movie-body .movie-title>div:first-child span{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 1rem;
  font-weight: 700;
  color: #4a3a5c;
}
.movie-content .movie-body .movie-title>div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background: linear-gradient(120deg, #f7a1c0 0%, #c3a3f2 55%, #ffbe9c 100%);
  border-radius: 25px;
  margin-right: 10px;
}
.movie-play-item{
  width: 100%;
  height: 200px;
  border-radius: 10px;
  position: relative;
  display: flex;
  background-color: #fff;
  margin-bottom: 20px;
}
.movie-play-item>div{
  height: 100%;
}
.movie-play-item>div:first-child {
  width: 200px;
  position: relative;
}
.movie-play-item>div:first-child>img{
  width: 100%;
  height: 100%;
  border-radius: 10px 0 0 10px;
}
.movie-play-item>div:first-child>div{
  position: absolute;
  width: 100%;
  height: 30px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  background-color: rgba(0,0,0,.4);
  border-radius: 0 0 0 10px;
}
.movie-play-item>div:first-child>div .van-count-down {
  color: #fff;
  font-size: 25px;
}
.movie-play-item>div:nth-child(2) p{
  width: 500px;
  height: 60px;
  font-size: 30px;
  line-height: 32px;
  word-break: break-all;
  overflow: hidden;
  color: #000;
}
.movie-play-item>div:nth-child(2) span{
  color: #000;
}
.movie-play-item>div:nth-child(2) {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
abbr, address, article, aside, audio, b, blockquote, body, canvas, caption, cite, code, dd, del, details, dfn, div, dl, dt, em, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, i, iframe, img, ins, kbd, label, legend, li, mark, menu, nav, object, ol, p, pre, q, samp, section, small, span, strong, sub, summary, sup, table, tbody, td, tfoot, th, thead, time, tr, ul, var, video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
}

.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}
.wrap{
  display: flex;
  flex-wrap: wrap;
  padding: 0.2rem 0.2rem 1rem;
  .video_wrap {
    height: auto;
    width: 50%;
    margin-top: 0.7rem;
  }
  .video {
    margin: 0 0.28rem;
    height: auto;
    position: relative;
    border-radius: 1rem;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 0.3rem 0.85rem rgba(183, 156, 236, 0.14);
    .van-image{
      width: 100%;
      height: 8rem;
      display: block;
    }
    ::v-deep .van-image__img {
      width: 100%;
      height: 8rem;
      object-fit: cover;
    }
    .info {
      height: auto;
      width: 100%;
      position: static;
      background: #fff;
      padding: 0.4rem 0.45rem 0.5rem;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .label, .value {
        width: 100%;
        padding: 0;
        font-size: 0.78rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
      }
      .label {
        color: #4a3a5c;
        font-weight: 600;
      }
      .value {
        margin-top: 0.12rem;
        color: #a99cba;
        font-size: 0.7rem;
      }
    }
  }
}
</style>